import './Home.css';
import AppBar from "../atoms/AppBar";
import { FaGithub, FaTwitter, FaLinkedin, FaGraduationCap, FaEnvelope, FaBrain, FaEye, FaNetworkWired } from 'react-icons/fa';
import homeData from '../../Data/jsons/latest_news.json';

function Home() {
	const profile = homeData.profile;
	const news = homeData.news;

	return (
		<div className="home-container">
			<AppBar />

			{/* Bio Section */}
			<section className="bio-section">
				<div className="bio-content">
					<div className="bio-photo">
						<img src={profile.profilePic} alt="Rohith Peddi" className="profile-pic" />
					</div>
					<div className="bio-text">
						<h1 className="bio-name">Rohith Peddi</h1>
						<p className="bio-title">Ph.D. Candidate in Computer Science</p>
						<p className="bio-affiliation">The University of Texas at Dallas</p>
						<p className="bio-advisors">
							Advised by <a href="https://www.hlt.utdallas.edu/~vgogate/" target="_blank" rel="noopener noreferrer">Dr. Vibhav Gogate</a> and <a href="https://yuxng.github.io/" target="_blank" rel="noopener noreferrer">Dr. Yu Xiang</a>
						</p>
						<p className="bio-statement">
							My research focuses on building Neuro-Symbolic multi-modal AI systems for spatio-temporal scene understanding, combining neural perception with symbolic reasoning for interpretable and robust intelligence.
						</p>
						<div className="bio-links">
							<a href={`mailto:${profile.email || 'rohith.peddi@utdallas.edu'}`} className="bio-link" aria-label="Email">
								<FaEnvelope size={16} />
								<span>Email</span>
							</a>
							<a href={profile.socialLinks.scholar} target="_blank" rel="noopener noreferrer" className="bio-link" aria-label="Google Scholar">
								<FaGraduationCap size={16} />
								<span>Scholar</span>
							</a>
							<a href={profile.socialLinks.github} target="_blank" rel="noopener noreferrer" className="bio-link" aria-label="GitHub">
								<FaGithub size={16} />
								<span>GitHub</span>
							</a>
							<a href={profile.socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="bio-link" aria-label="LinkedIn">
								<FaLinkedin size={16} />
								<span>LinkedIn</span>
							</a>
							<a href={profile.socialLinks.twitter} target="_blank" rel="noopener noreferrer" className="bio-link" aria-label="Twitter">
								<FaTwitter size={16} />
								<span>Twitter</span>
							</a>
						</div>
					</div>
				</div>
			</section>

			{/* Research Areas Section */}
			<section className="research-areas-section">
				<div className="section-container">
					<h2 className="home-section-title">Research Areas</h2>
					<div className="research-areas-grid">
						<div className="research-area-card">
							<div className="area-icon">
								<FaBrain size={22} />
							</div>
							<div className="research-area-content">
								<h3>Neuro-Symbolic AI</h3>
								<p>Combining neural networks with symbolic reasoning for interpretable and robust AI systems.</p>
							</div>
						</div>
						<div className="research-area-card">
							<div className="area-icon">
								<FaEye size={22} />
							</div>
							<div className="research-area-content">
								<h3>Computer Vision</h3>
								<p>Multi-modal perception with symbolic scene understanding and logical reasoning.</p>
							</div>
						</div>
						<div className="research-area-card">
							<div className="area-icon">
								<FaNetworkWired size={22} />
							</div>
							<div className="research-area-content">
								<h3>Robotics & Planning</h3>
								<p>Machine learning approaches for robotics and task planning with logical constraints.</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* News Section */}
			<section className="news-section">
				<div className="section-container">
					<h2 className="home-section-title">Latest News</h2>
					<div className="news-table">
						<div className="news-table-header">
							<span>Date</span>
							<span>Category</span>
							<span>Description</span>
							<span>Link</span>
						</div>
						{news.map((item, index) => (
							<div key={index} className="news-row">
								<span className="news-date">{item.date}</span>
								<span className={`news-tag ${item.tagColor}`}>{item.category}</span>
								<span className="news-text">{item.description}</span>
								<span className="news-link-cell">
									{item.link ? (
										<a href={item.link} target="_blank" rel="noopener noreferrer" className="news-link">
											[link]
										</a>
									) : (
										<span className="news-no-link">—</span>
									)}
								</span>
							</div>
						))}
					</div>
				</div>
			</section>

			{/* Footer */}
			<footer className="site-footer">
				<p>© 2026 Rohith Peddi · Last updated March 2026</p>
			</footer>
		</div>
	);
}

export default Home;
